import Button from './Button/Button.css';
import Modal from './Modal/Modal.css';
import SexSelector from './SexSelector/SexSelector.css';
export default {
    Button,
    Modal,
    SexSelector
};
